import React from 'react';
import { Toaster } from 'react-hot-toast';
import { Navigate, Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import Login from './components/Auth/Login';
import ProfilePage from './components/Common/ProfilePage';
import SettingsPage from './components/Common/SettingsPage';
import EmployeeDashboard from './components/Dashboard/EmployeeDashboard';
import HRDashboard from './components/Dashboard/HRDashboard';
import OwnerDashboard from './components/Dashboard/OwnerDashboard';
import ProjectManagerDashboard from './components/Dashboard/ProjectManagerDashboard';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { DataProvider } from './contexts/DataContext';
import './styles/App.css';
import './styles/index.css';

// Protected Route Component
const ProtectedRoute = ({ children }) => {
  const { currentUser } = useAuth();
  return currentUser ? children : <Navigate to="/login" />;
};

function AppContent() {
  const { currentUser, loading } = useAuth();

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  const renderDashboard = () => {
    if (!currentUser) return <Navigate to="/login" />;

    switch (currentUser.role) {
      case 'owner':
        return <OwnerDashboard />;
      case 'project_manager':
        return <ProjectManagerDashboard />;
      case 'hr':
        return <HRDashboard />;
      case 'employee':
        return <EmployeeDashboard />;
      default:
        return <EmployeeDashboard />;
    }
  };

  return (
    <Router>
      <div className="App">
        <Toaster position="top-right" />
        <Routes>
          <Route 
            path="/login" 
            element={!currentUser ? <Login /> : <Navigate to="/dashboard" />} 
          />
          <Route 
            path="/dashboard/*" 
            element={renderDashboard()} 
          />
          
          {/* Profile and Settings Routes */}
          <Route 
            path="/profile" 
            element={<ProtectedRoute><ProfilePage /></ProtectedRoute>} 
          />
          <Route 
            path="/profile/:userId" 
            element={<ProtectedRoute><ProfilePage /></ProtectedRoute>} 
          />
          <Route 
            path="/settings" 
            element={<ProtectedRoute><SettingsPage /></ProtectedRoute>} 
          />
          
          <Route 
            path="/" 
            element={<Navigate to={currentUser ? "/dashboard" : "/login"} />} 
          />
        </Routes>
      </div>
    </Router>
  );
}

function App() {
  return (
    <AuthProvider>
      <DataProvider>
        <AppContent />
      </DataProvider>
    </AuthProvider>
  );
}

export default App;
